'use client'

import { useRef, useState } from 'react'
import useMediaQuery from '@/utils/browser/getDeviceScreen'

const useCases = () => {
  const isMobile = useMediaQuery('mobile')
  const [visibleCardIndex, setVisibleCardIndex] = useState(0)

  const listRef = useRef(null)
  const itemsRefs = useRef([])

  const isOnScreen = (element) => {
    if (!element) {
      return false
    }

    const { x } = element.getBoundingClientRect()

    return x > 0 && x < 80
  }

  const onScroll = () => {
    const newVisibleCardIndex = itemsRefs.current.findIndex((benefit) =>
      isOnScreen(benefit)
    )

    if (newVisibleCardIndex >= 0 && newVisibleCardIndex !== visibleCardIndex) {
      setVisibleCardIndex(newVisibleCardIndex)
    }
  }

  const onClickController = (direction) => {
    const directions = {
      left: visibleCardIndex - 1,
      right: visibleCardIndex + 1
    }

    const nextVisibleCard = itemsRefs.current[directions[direction]]
    const { top, left } = nextVisibleCard.getBoundingClientRect()

    listRef.current.scrollBy({
      top,
      left,
      behavior: 'smooth'
    })
  }

  return {
    isMobile,
    visibleCardIndex,
    listRef,
    itemsRefs,
    onScroll,
    onClickController
  }
}

export default useCases
